import { ChangeEvent } from 'react'

import { useForm, useSetState } from '@domain-group/react-hooks'

import {
  DynamicInput, Form, LoadingBubbles, Text,
} from '@domain-group/suit-theme'

import type { OrderReconciliationPayload } from '@hooks/useOrderReconciliation'

// @ts-expect-error TS2724
import defaultState, { ReconciliationItem } from '@models/reconciliationItem'

const permittedKeys = {
  invoice_notes: {
    elementType: 'input',
    type: 'text',
  },
  invoice_reference: {
    elementType: 'input',
    type: 'text',
  },
  invoice_total: {
    elementType: 'input',
    type: 'number',
  },
  paid_by: {
    elementType: 'select',
    options: [
      { key: 'agency', label: 'Paid by Agency' },
      { key: 'agent', label: 'Paid by Agent' },
      { key: 'commission', label: 'Paid from Commission' },
      { key: 'vendor', label: 'Paid by Vendor' },
    ],
  },
}

const localState = {
  updating: false,
}

interface EditableTableItemProps {
  callbacks: OrderReconciliationPayload['callbacks'],
  dataKey: string,
  item: ReconciliationItem,
}

const EditableTableItem = (props: EditableTableItemProps) => {
  const {
    callbacks: { updateItem },
    dataKey,
    item,
    item: { editable, id },
  } = props

  const [state, setState] = useSetState(localState)
  const { updating } = state

  const itemForm = useForm(defaultState, {
    entity: item,
    validateOn: 'change',
  })
  const {
    entityState,
    setEntityState,
  } = itemForm

  const value = entityState[dataKey]

  // @ts-expect-error TS7053
  const { elementType, options, type } = permittedKeys[dataKey] || {}

  if (updating) return <LoadingBubbles />

  if (!editable || !elementType) return <Text>{value}</Text>

  return (
    <Form.Field>
      <DynamicInput
        currentValue={value || ''}
        key={dataKey}
        inputType={type}
        inputComponent={elementType}
        onBlur={() => {
          setState({ updating: true })
          // @ts-expect-error TS2339
          updateItem(item, { id, [dataKey]: value }).then(() => setState({ updating: false }))
        }}
        onChange={(e?: ChangeEvent<HTMLInputElement>) => setEntityState({ [dataKey]: e?.target.value })}
        name={dataKey}
        values={options}
      />
    </Form.Field>
  )
}

export default EditableTableItem
